module.exports = __webpack_public_path__ + "static/media/B1en.8d7364e1.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/B1en.png
// module id = 880
// module chunks = 0